import type { CubeLook } from '../../render/icons';
import { CubePreview } from './CubePreview';
import './Logo.css';

/** The brand cube (same colours as the app icon from scripts/gen-icons.mjs). */
const BRAND_CUBE: CubeLook = { icon: 'classic', primary: 'lime', secondary: 'cyan' };

/** Spinning cube + stylised "CUBE RUSH" title. */
export function Logo() {
  return (
    <div class="logo">
      <CubePreview look={BRAND_CUBE} size={64} spin glow class="logo__cube" />
      <h1 class="logo__title">
        <span class="logo__word logo__word--cube">CUBE</span>
        <span class="logo__word logo__word--rush">RUSH</span>
      </h1>
    </div>
  );
}
